/* ============================================================
   V8 EQUIPMENT — comportements du site (brief V2)
   Un seul fichier, des gardes partout : chaque bloc fonctionne
   même si l'élément est absent de la page.
   ============================================================ */
(function(){
  "use strict";

  /* ---------- CONFIGURATION (un seul endroit) ---------- */
  var B = document.body.dataset;
  var CFG = {
    whatsapp: B.whatsapp || "",
    season: { name: B.seasonName || "Automne 2026", open: B.seasonOpen || "2026-09-23T09:00:00+02:00", close: B.seasonClose || "2026-12-23T09:00:00+01:00", next: B.seasonNext || "l'hiver", nextOpen: B.seasonNextOpen || "2026-12-23T09:00:00+01:00" },
    tiers: (B.tiers || "100,200,500").split(",").map(Number),
    freeShipping: parseFloat(B.freeShipping || "80"),
    cartTotal: parseFloat(B.cartTotal || "0") / 100,   // total du panier Shopify (centimes), rendu par Liquid
    cartCount: parseInt(B.cartCount || "0", 10)
  };

  var reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
  var fine   = window.matchMedia("(hover:hover) and (pointer:fine)").matches;
  var root = document.documentElement;
  var $  = function(s,c){ return (c||document).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };
  if(reduce) root.classList.add("reduce");

  var now = new Date();
  var OPEN = new Date(CFG.season.open), CLOSE = new Date(CFG.season.close), NEXT = new Date(CFG.season.nextOpen);

  /* ---------- ÉTAT DU SITE : veille / drop / saison fermée ---------- */
  var q = new URLSearchParams(location.search);
  try{
    if(q.get("preview")==="1") localStorage.setItem("v8preview","1");
    if(q.get("preview")==="0") localStorage.removeItem("v8preview");
  }catch(e){}
  var preview = false; try{ preview = localStorage.getItem("v8preview")==="1"; }catch(e){}
  var phase = now < OPEN ? "pre" : (now < CLOSE ? "open" : "closed");
  if(preview && phase==="pre") phase = "open";
  // Les ventes ne sont jamais bloquées : la phase ne sert qu'au compte à rebours et aux libellés.
  root.classList.toggle("closed", phase==="closed");
  root.setAttribute("data-phase", phase);

  /* ---------- COMPTE À REBOURS : identique partout ---------- */
  function pad(n){ return (n<10?"0":"")+n; }
  var target = phase==="pre" ? OPEN : (phase==="open" ? CLOSE : NEXT);
  var counts = $$("[data-count]");
  function tick(){
    var d = Math.max(0, target - new Date());
    var days = Math.floor(d/864e5), h = Math.floor(d%864e5/36e5), m = Math.floor(d%36e5/6e4), s = Math.floor(d%6e4/1e3);
    counts.forEach(function(el){
      /* data-count-to : une cible propre (la clôture des candidatures), au
         lieu de la date de saison. */
      var propre = el.getAttribute("data-count-to");
      var dd = d, hh = h, mm = m, ss = s, jj = days;
      if(propre){
        var cible = new Date(propre); if(!isNaN(cible)){
          dd = Math.max(0, cible - new Date());
          jj = Math.floor(dd/864e5); hh = Math.floor(dd%864e5/36e5); mm = Math.floor(dd%36e5/6e4); ss = Math.floor(dd%6e4/1e3);
        }
      }
      var b = el.querySelectorAll("b");
      if(b.length>=4){ b[0].textContent = jj; b[1].textContent = pad(hh); b[2].textContent = pad(mm); b[3].textContent = pad(ss); }
    });
    $$("[data-days-left]").forEach(function(el){ el.textContent = days; });
  }
  if(counts.length){ tick(); setInterval(tick, 1000); }
  $$("[data-phase-label]").forEach(function(el){ el.textContent = phase==="pre" ? "Ouverture dans" : (phase==="open" ? "Fin de la saison dans" : "Réouverture dans"); });
  $$("[data-count-label]:not([data-fixed])").forEach(function(el){
    el.textContent = phase==="pre" ? "Ouverture de la saison" : (phase==="open" ? "Fin de la saison" : "Ouverture de " + CFG.season.next);
  });

  /* ---------- DÉCOR VIVANT : la même photo, 12 états, un par semaine ---------- */
  // saturation, luminosité, teinte (deg), voile haut, voile milieu, teinte de saison (rgba)
  var STATES = [
    [1.05,1.00,0,  .30,.42,"rgba(217,104,63,0)"],
    [1.02,0.98,-2, .31,.43,"rgba(217,104,63,.03)"],
    [1.00,0.96,-4, .32,.44,"rgba(217,104,63,.06)"],
    [0.98,0.94,-6, .33,.45,"rgba(217,104,63,.09)"],
    [0.96,0.92,-8, .34,.46,"rgba(217,104,63,.12)"],
    [0.94,0.90,-10,.35,.47,"rgba(217,104,63,.15)"],
    [0.92,0.88,-12,.36,.48,"rgba(217,104,63,.18)"],
    [0.90,0.86,-14,.37,.49,"rgba(217,104,63,.21)"],
    [0.88,0.84,-16,.38,.50,"rgba(217,104,63,.24)"],
    [0.86,0.82,-18,.40,.52,"rgba(217,104,63,.26)"],
    [0.84,0.80,-20,.42,.54,"rgba(217,104,63,.28)"],
    [0.82,0.78,-22,.44,.56,"rgba(217,104,63,.30)"]
  ];
  $$(".decor").forEach(function(decor){
    var wk = Math.floor((now - OPEN)/(7*864e5)); if(wk<0) wk = 0; if(wk>11) wk = 11;
    var s = STATES[wk];
    var map = {"--d-sat":s[0],"--d-bri":s[1],"--d-hue":s[2]+"deg","--d-top":s[3],"--d-mid":s[4],"--d-tint":s[5]};
    Object.keys(map).forEach(function(k){ decor.style.setProperty(k, map[k]); });
    decor.setAttribute("data-week", wk+1);
    if(!reduce && decor.hasAttribute("data-zoom")) decor.classList.add("zoom");
  });

  /* ---------- VIDÉO DU HÉRO : ordinateur seulement, chargée après la page, en pause hors écran ---------- */
  var vids = $$(".hero-video");
  var wantVideo = vids.length && !reduce && window.matchMedia("(min-width:1024px)").matches && !(navigator.connection && navigator.connection.saveData);
  if(wantVideo && "IntersectionObserver" in window){
    vids.forEach(function(v){
      var srcs = (v.getAttribute("data-src")||"").split("|").filter(Boolean);
      function load(){
        if(v.getAttribute("data-loaded")) return; v.setAttribute("data-loaded","1");
        srcs.forEach(function(u){ var so = document.createElement("source"); so.src = u; so.type = /\.webm/.test(u) ? "video/webm" : "video/mp4"; v.appendChild(so); });
        v.load();
      }
      var held = false; // l'utilisateur a mis en pause : on ne relance pas tout seul (WCAG 2.2.2)
      var ctl = (v.closest(".hero") || document).querySelector("[data-vid-ctl]");
      function play(){ if(held) return; var p = v.play(); if(p && p.catch) p.catch(function(){}); }
      function setCtl(){ if(!ctl) return; ctl.hidden = false; ctl.setAttribute("aria-pressed", held); ctl.classList.toggle("held", held); var l = ctl.querySelector("[data-vid-label]"); if(l) l.textContent = held ? "Lecture" : "Pause"; }
      v.addEventListener("playing", function(){ v.classList.add("on"); setCtl(); });
      if(ctl) ctl.addEventListener("click", function(){ held = !held; if(held) v.pause(); else play(); setCtl(); });
      var vio = new IntersectionObserver(function(es){
        es.forEach(function(en){ if(en.isIntersecting){ load(); play(); } else if(!v.paused){ v.pause(); } });
      }, {threshold:.05});
      if(document.readyState === "complete") vio.observe(v); else window.addEventListener("load", function(){ vio.observe(v); });
    });
  }

  /* ---------- HEADER : posé sur l'image, se rétracte au défilement ---------- */
  var hdr = $("#nav"), lastY = window.pageYOffset;
  var darkHero = $(".hero.dark, .veille.dark");
  /* Lire offsetTop/offsetHeight à chaque défilement force un recalcul de
     mise en page (mesuré par PageSpeed : « ajustement forcé »). On mesure
     une fois, et à nouveau seulement quand la fenêtre change. */
  var heroBas = -1;
  function mesureHero(){ heroBas = (darkHero && darkHero.offsetParent !== null) ? darkHero.offsetTop + darkHero.offsetHeight - 70 : -1; }
  mesureHero(); window.addEventListener("resize", mesureHero, {passive:true}); window.addEventListener("load", mesureHero);
  function onScroll(){
    var y = window.pageYOffset;
    if(hdr){
      /* 22 sept. : la barre est posée en haut de page (position absolue), elle ne se rétracte plus */
      hdr.classList.toggle("stuck", y > 60);
      /* Le site est sombre partout sauf sur les pages marquées « light »
         (fiche produit, panier) : la barre s'y met en texte noir. */
      var pageClaire = document.body.classList.contains("light");
      var overDark = root.classList.contains("menu-open") || !pageClaire
                  || (heroBas > 0 && y < heroBas);
      hdr.classList.toggle("on-dark", !!overDark);
    }
    lastY = y;
  }
  window.addEventListener("scroll", onScroll, {passive:true}); onScroll();


  /* ---------- RESTER AU COURANT : le canal accepté part en étiquette ---------- */
  (function(){
    var f = document.querySelector(".optin-f");
    if(!f) return;
    var champ  = f.querySelector("[data-optin-tags]");
    var cases  = f.querySelectorAll("[data-canal]");
    var mail   = f.querySelector("[data-canal='optin-email']");
    if(!champ || !cases.length) return;

    var bloctel = f.querySelector("[data-optin-tel]");
    var tel     = f.querySelector("[data-tel]");
    var sms     = f.querySelector("[data-canal='optin-sms']");
    var wa      = f.querySelector("[data-canal='optin-whatsapp']");

    function veutTel(){ return (sms && sms.checked) || (wa && wa.checked); }

    function noter(){
      var t = [];
      for(var i=0;i<cases.length;i++){ if(cases[i].checked) t.push(cases[i].getAttribute("data-canal")); }
      t.push("source-accueil");
      /* Le formulaire client de Shopify ne porte pas de champ téléphone : le
         numéro voyage dans les étiquettes, préfixé, pour rester retrouvable
         et effaçable sur simple demande. */
      if(tel){
        var n = (tel.value || "").replace(/[^0-9+]/g, "");
        if(n.length >= 9 && veutTel()) t.push("tel-" + n);
      }
      champ.value = t.join(",");
      if(mail && !mail.checked){ mail.checked = true; }
    }

    function majTel(){
      if(!bloctel) return;
      var ouvert = veutTel();
      bloctel.hidden = !ouvert;
      if(tel) tel.required = ouvert;
      if(!ouvert && tel) tel.value = "";
      noter();
    }

    for(var i=0;i<cases.length;i++){ cases[i].addEventListener("change", majTel); }
    if(tel) tel.addEventListener("input", noter);
    f.addEventListener("submit", noter);
    majTel();
  })();

  /* ---------- RESTER AU COURANT : le contact part aussi dans Resend ----------
     Tout formulaire client qui porte data-relais prévient le relais
     Cloudflare à l'envoi (segment « Newsletter »), puis laisse le POST
     natif partir vers Shopify. keepalive : la page navigue juste après.
     Si le relais ne répond pas, l'inscription est quand même dans
     Shopify. Le téléphone ne part pas : il voyage dans les étiquettes
     Shopify, on ne le duplique pas ailleurs. */
  [].forEach.call(document.querySelectorAll("form[data-relais]"), function(f){
    var url = f.getAttribute("data-relais");
    if(!url) return;
    f.addEventListener("submit", function(){
      var mail = f.querySelector("[name='contact[email]']");
      if(!mail || !mail.value) return;
      var prenom = f.querySelector("[name='contact[first_name]']");
      var tags = f.querySelector("[name='contact[tags]']");
      var canaux = (tags && tags.value ? tags.value.split(",") : []).filter(function(t){ return /^optin-/.test(t); });
      try{
        fetch(url, {method:"POST", keepalive:true, headers:{"Content-Type":"application/json"},
          body: JSON.stringify({type:"lettre", email: mail.value, Prenom: prenom ? prenom.value : "",
            canaux: canaux.join(","), source: f.getAttribute("data-relais-source") || "lettre"})});
      }catch(e){}
    });
  });

  /* ---------- LA MARCHE : on avance dans la scène (maquette V5, §3.2-3.3) ----------
     Les repères vivent dans un <svg> qui porte le viewBox de la photo et le
     même cadrage qu'elle. On lit la position réelle de chaque ancre avec
     getScreenCTM() et on pose l'étiquette HTML dessus : la photo peut être
     recadrée par object-fit, les repères restent sur l'objet. C'est le défaut
     que le LISEZ-MOI de la maquette demandait de corriger. */
  (function(){
    var sec = $("[data-marche]"); if(!sec) return;
    var zoom  = $("[data-marche-zoom]", sec),
        titre = $("[data-marche-titre]", sec),
        rep   = $("[data-marche-rep]", sec),
        svgs  = $$(".mst-svg", sec);
    var pts = $$(".mst-pt", sec);
    if(!svgs.length || !pts.length) return;

    /* Deux calques, un par cadrage : celui de la photo paysage et celui de la
       photo portrait. Le CSS n'en montre qu'un ; on prend celui qui mesure
       quelque chose. L'autre est display:none et renvoie une largeur nulle. */
    function calque(){
      for(var i = 0; i < svgs.length; i++){
        if(svgs[i].getBoundingClientRect().width > 0) return svgs[i];
      }
      return null;
    }

    /* --- poser chaque étiquette sur son ancre --- */
    function poser(){
      var svg = calque(); if(!svg) return;
      var ancres = $$(".mst-ancre", svg);
      var cadre = svg.getBoundingClientRect();
      var m = svg.getScreenCTM(); if(!m) return;
      for(var i = 0; i < ancres.length; i++){
        var a = ancres[i], pt = pts[i]; if(!pt) continue;
        var x = a.cx.baseVal.value, y = a.cy.baseVal.value;
        var ex = x * m.a + y * m.c + m.e - cadre.left;
        var ey = x * m.b + y * m.d + m.f - cadre.top;
        pt.style.left = ex + "px";
        pt.style.top  = ey + "px";
        /* l'étiquette bascule vers l'intérieur quand le point serre un bord */
        var r = ex / cadre.width;
        pt.classList.toggle("a-gauche", r > .74);
        pt.classList.toggle("a-droite", r < .26);
        pt.classList.toggle("en-bas", ey / cadre.height > .66);
      }
    }

    /* --- la progression du scroll dans le conteneur haut --- */
    function prog(){
      var r = sec.getBoundingClientRect(), course = r.height - window.innerHeight;
      if(course <= 0) return 1;
      return Math.min(1, Math.max(0, -r.top / course));
    }
    var enAttente = false;
    function auScroll(){
      if(enAttente) return;
      enAttente = true;
      requestAnimationFrame(function(){
        enAttente = false;
        var p = prog();
        if(!reduce && zoom) zoom.style.transform = "scale(" + (1 + p * 0.26) + ")";
        if(titre) titre.classList.toggle("on", p > .16 && p < .94);
        if(rep){
          var vu = reduce || p > .34;
          rep.classList.toggle("on", vu);
          if(vu) poser();
        }
      });
    }

    /* --- un repère ouvert à la fois --- */
    function seul(pt){
      pts.forEach(function(q){
        var oui = q === pt;
        q.classList.toggle("ouvert", oui);
        var b = $(".mst-dot", q); if(b) b.setAttribute("aria-expanded", oui ? "true" : "false");
      });
      /* Le projecteur : la zone du repère ouvert reste claire, le reste
         s'assombrit un peu. C'est ce contraste qui guide l'œil. */
      var mst = $(".mst", sec);
      if(mst){
        mst.classList.toggle("focus", !!pt);
        if(pt){
          var r = pt.getBoundingClientRect(), R = mst.getBoundingClientRect();
          mst.style.setProperty("--fx", (r.left + r.width/2 - R.left) + "px");
          mst.style.setProperty("--fy", (r.top + r.height/2 - R.top) + "px");
        }
      }
    }
    pts.forEach(function(pt){
      var dot = $(".mst-dot", pt); if(!dot) return;
      dot.addEventListener("click", function(e){
        e.stopPropagation();
        seul(pt.classList.contains("ouvert") ? null : pt);
      });
      dot.addEventListener("focus", function(){ seul(pt); });
      if(fine){
        pt.addEventListener("mouseenter", function(){ seul(pt); });
      }
    });
    if(fine && rep) rep.addEventListener("mouseleave", function(){ seul(null); });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") seul(null); });
    document.addEventListener("click", function(e){ if(!sec.contains(e.target)) seul(null); });

    window.addEventListener("scroll", auScroll, {passive:true});
    window.addEventListener("resize", function(){ poser(); auScroll(); }, {passive:true});
    /* Le <picture> change de source au franchissement de 760 px : la nouvelle
       photo se charge, et le cadrage bouge. On repose au chargement, sinon les
       repères restent sur les coordonnées de l'autre cadrage. */
    var photo = $(".mst-photo", sec);
    if(photo){
      if(!photo.complete) photo.addEventListener("load", poser, {once:true});
      photo.addEventListener("load", poser);
    }
    if(reduce && rep){ rep.classList.add("on"); if(titre) titre.classList.add("on"); }
    poser(); auScroll();
  })();

  /* ---------- REBOND PRODUIT : le deuxième cercle s'ouvre au premier ajout ----------
     Brief du 12 septembre. Les cartes de complément ajoutent au panier sans
     quitter la fiche et sans ouvrir le tiroir : une confirmation en place, le
     compteur de palier fait le reste. Une fois révélé, le complément 2 ne se
     referme plus, y compris si le produit est retiré du panier. Sans JS ou en
     mouvement réduit, les deux compléments sont servis affichés. */
  (function(){
    var sec = $("[data-rebond]"); if(!sec) return;
    var suite = $("[data-reb-suite]", sec);

    if(reduce && suite){ suite.hidden = false; suite.classList.add("ouvert"); }

    function reveler(){
      if(!suite || !suite.hidden) return;
      suite.hidden = false;
      /* un cadre pour que la transition parte d'un état posé */
      requestAnimationFrame(function(){
        suite.classList.add("ouvert");
        if(!reduce && window.innerWidth < 900){
          var y = suite.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({top: y, behavior: "smooth"});
        }
      });
    }

    $$("[data-reb-form]", sec).forEach(function(f){
      f.addEventListener("submit", function(e){
        e.preventDefault();
        var btn = $("[data-reb-add]", f); if(!btn || btn.disabled) return;
        var carte = f.closest("[data-reb-carte]"), ok = carte ? $("[data-reb-ok]", carte) : null;
        btn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: {"Content-Type": "application/json", "Accept": "application/json"},
          body: JSON.stringify({items: [{id: parseInt(btn.getAttribute("data-reb-add"), 10), quantity: 1}]})
        })
        .then(function(r){ if(!r.ok) throw new Error("ajout refusé"); return fetch("/cart.js"); })
        .then(function(r){ return r.json(); })
        .then(function(c){
          cartTotal = c.total_price / 100; cartCount = c.item_count;
          renderCount(); renderTiers();
          if(ok){ ok.hidden = false; }
          if(carte) carte.classList.add("ajoute");
          btn.disabled = false;
          reveler();
        })
        .catch(function(){
          btn.disabled = false;
          say("Impossible d'ajouter pour l'instant.");
        });
      });
    });
  })();

  /* ---------- MONDES : les fonds défilent derrière le produit (brief §4.1) ---------- */
  (function(){
    var sections = [].slice.call(document.querySelectorAll("[data-mondes]"));
    if(!sections.length || root.classList.contains("reduce")) return;

    sections.forEach(function(sec){
      var stage  = sec.querySelector("[data-stage]");
      var fonds  = [].slice.call(sec.querySelectorAll(".fnd"));
      var legs   = [].slice.call(sec.querySelectorAll(".leg .bloc"));
      var bars   = [].slice.call(sec.querySelectorAll(".prog i"));
      var ombre  = sec.querySelector("[data-ombre]");
      var n = fonds.length;
      if(!stage || n < 2) return;

      var courant = -1, tick = false;

      /* on ne charge que le fond affiché et le suivant, jamais les quatre
         (LISEZ-MOI §7 : budget LCP en 4G) */
      function charge(f){
        if(!f || f.dataset.pre) return;
        /* la photo large seulement quand l'écran la mérite (LISEZ-MOI §7) */
        var large = window.innerWidth > 900 || window.devicePixelRatio > 1.5;
        var src = large ? f.getAttribute("data-src") : (f.getAttribute("data-src-900") || f.getAttribute("data-src"));
        if(!src) return;
        f.dataset.pre = "1";
        var im = new Image();
        im.onload = function(){ f.style.backgroundImage = "url(" + src + ")"; };
        im.src = src;
      }

      function poser(i){
        if(i === courant) return;
        courant = i;
        charge(fonds[i]);
        charge(fonds[i+1]);
        fonds.forEach(function(f,k){ f.classList.toggle("on", k === i); });
        legs.forEach(function(l,k){ l.classList.toggle("on", k === i); });
        bars.forEach(function(b,k){ b.classList.toggle("on", k <= i); });
        var dir = fonds[i].getAttribute("data-ombre") || "dessous";
        /* l'ombre portée change de côté ET d'intensité avec la lumière du
           fond : forte à l'aube, presque nulle la nuit. Sans ça le produit a
           l'air collé (LISEZ-MOI §3.4). */
        var op = parseFloat(fonds[i].getAttribute("data-opacite"));
        if(ombre){
          ombre.setAttribute("data-dir", dir);
          ombre.style.opacity = isNaN(op) ? 0.42 : Math.min(1, Math.max(0, op));
        }
        stage.classList.toggle("nuit", dir === "nuit");
      }

      function mesure(){
        var r = sec.getBoundingClientRect();
        var course = r.height - window.innerHeight;
        if(course <= 0) return poser(0);
        var p = Math.min(1, Math.max(0, -r.top / course));
        poser(Math.min(n - 1, Math.floor(p * n)));
        tick = false;
      }
      function onScrollMondes(){ if(!tick){ tick = true; requestAnimationFrame(mesure); } }
      window.addEventListener("scroll", onScrollMondes, {passive:true});
      window.addEventListener("resize", onScrollMondes);
      mesure();

      /* la torche suit le curseur, et le doigt sur mobile */
      function torche(x, y){
        var r = stage.getBoundingClientRect();
        sec.style.setProperty("--mx", (x - r.left) + "px");
        sec.style.setProperty("--my", (y - r.top) + "px");
        var pts = sec.querySelectorAll("[data-detail]");
        for(var i = 0; i < pts.length; i++){
          var b = pts[i].getBoundingClientRect();
          var dx = (b.left + b.width/2) - x, dy = (b.top + b.height/2) - y;
          pts[i].classList.toggle("lit", Math.sqrt(dx*dx + dy*dy) < 150);
        }
      }
      stage.addEventListener("mousemove", function(e){ torche(e.clientX, e.clientY); });
      stage.addEventListener("touchmove", function(e){
        var t = e.touches[0]; if(t) torche(t.clientX, t.clientY);
      }, {passive:true});
    });
  })();


  /* ---------- COMPATIBILITÉ VÉHICULE (brief §5) ---------- */
  (function(){
    [].forEach.call(document.querySelectorAll(".compat"), function(mod){
      var onglets = [].slice.call(mod.querySelectorAll("[data-veh]"));
      if(!onglets.length) return;
      function montre(id, focus){
        onglets.forEach(function(o){
          var actif = o.getAttribute("data-veh") === id;
          o.setAttribute("aria-selected", actif ? "true" : "false");
          o.tabIndex = actif ? 0 : -1;
          if(actif && focus) o.focus();
        });
        [].forEach.call(mod.querySelectorAll("[data-panneau]"), function(p){
          p.hidden = p.getAttribute("data-panneau") !== id;
        });
      }
      mod.addEventListener("click", function(e){
        var b = e.target.closest("[data-veh]");
        if(b) montre(b.getAttribute("data-veh"), false);
      });
      /* flèches gauche/droite entre les onglets, comme l'attend un tablist */
      mod.addEventListener("keydown", function(e){
        if(e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
        var i = onglets.indexOf(document.activeElement);
        if(i < 0) return;
        e.preventDefault();
        var j = (i + (e.key === "ArrowRight" ? 1 : -1) + onglets.length) % onglets.length;
        montre(onglets[j].getAttribute("data-veh"), true);
      });
    });
  })();

  /* ---------- MENU PLEIN ÉCRAN (porte le manifeste) ---------- */
  var menu = $("#menu"), mOpen = $("#menuOpen"), mClose = $("#menuClose");
  function setMenu(open){
    if(!menu) return;
    menu.classList.toggle("open", open);
    menu.setAttribute("aria-hidden", !open);
    root.classList.toggle("menu-open", open);
    document.body.style.overflow = open ? "hidden" : "";
    if(mOpen) mOpen.setAttribute("aria-expanded", open);
    if(open){ var f = menu.querySelector("a,button"); if(f) f.focus(); } else if(mOpen) mOpen.focus();
    onScroll();
  }
  if(mOpen) mOpen.addEventListener("click", function(){ setMenu(true); });
  if(mClose) mClose.addEventListener("click", function(){ setMenu(false); });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape"){ setMenu(false); } });

  /* ---------- RECHERCHE (8 oct., Gaëtan) ----------
     La loupe ouvre un panneau ; les suggestions viennent de l'API suggest de Shopify
     (fiches, guides, pages) au fil de la frappe, avec le préfixe « last » pour que
     « tent » trouve « tente ». Entrée = la page de résultats, qui marche sans JS. */
  var srch = $("#srch"), sOpen = $("#searchOpen"), sIn = srch ? $("[data-srch-input]", srch) : null, sRes = srch ? $("[data-srch-res]", srch) : null, sT, sLast = "";
  function setSrch(open){
    if(!srch) return;
    srch.classList.toggle("open", open);
    srch.setAttribute("aria-hidden", !open);
    root.classList.toggle("srch-open", open);
    if(sOpen) sOpen.setAttribute("aria-expanded", open);
    if(open){ setMenu(false); setTimeout(function(){ if(sIn){ sIn.focus(); sIn.select(); } }, 60); }
    else if(sOpen && document.activeElement && srch.contains(document.activeElement)) sOpen.focus();
  }
  if(sOpen) sOpen.addEventListener("click", function(){ setSrch(true); });
  $$("[data-srch-close]").forEach(function(b){ b.addEventListener("click", function(){ setSrch(false); }); });
  if(srch) srch.addEventListener("click", function(e){ if(e.target === srch) setSrch(false); });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") setSrch(false); });
  function esc(s){ return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }
  function suggest(q){
    if(!sRes) return;
    if(q.length < 2){ sRes.innerHTML = ""; return; }
    var url = "/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product,page,article&resources[limit]=6&resources[options][prefix]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,tag,body";
    fetch(url, {headers:{"Accept":"application/json"}}).then(function(r){ return r.json(); }).then(function(d){
      if(q !== sLast) return;
      var r = (d && d.resources && d.resources.results) || {}, out = "";
      (r.products || []).forEach(function(p){
        var im = (p.featured_image && p.featured_image.url) || p.image || "";
        if(im) im += (im.indexOf("?") > -1 ? "&" : "?") + "width=96";
        var prix = p.price ? money(parseFloat(p.price)) : "";
        var typ = p.type || p.product_type || "";
        out += '<a href="' + esc(p.url) + '">' + (im ? '<img src="' + esc(im) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="ph"></span>') + '<span><b>' + esc(p.title) + '</b><small>' + esc(typ) + (prix ? (typ ? " · " : "") + prix : "") + '</small></span></a>';
      });
      var pg = (r.pages || []).concat(r.articles || []);
      if(pg.length){ out += '<p class="tag">Guides et pages</p>'; pg.forEach(function(p){ out += '<a href="' + esc(p.url) + '"><span><b>' + esc(p.title) + '</b></span></a>'; }); }
      if(!out) out = '<p class="tag">Rien pour « ' + esc(q) + ' ». Essaie un mot plus court.</p>';
      else out += '<a class="all" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">Voir tous les résultats</a>';
      sRes.innerHTML = out;
    }).catch(function(){});
  }
  if(sIn) sIn.addEventListener("input", function(){ var q = sIn.value.trim(); sLast = q; clearTimeout(sT); sT = setTimeout(function(){ suggest(q); }, 220); });

  /* ---------- APPARITIONS AU DÉFILEMENT ---------- */
  var reveals = $$(".rv");
  reveals.forEach(function(el){
    if(/\b(plaques|comps|heroes|pictos|situations|hotspots|univers|reviews|foryou|equiv|grid)\b/.test(el.className)){
      el.setAttribute("data-stagger","");
      Array.prototype.forEach.call(el.children, function(c,i){ c.style.setProperty("--i", Math.min(i, 6)); }); // 6 × 60 ms : la cascade s'arrête à 360 ms
    }
  });
  var lazies = $$("img[loading=lazy]");
  lazies.forEach(function(im){ if(im.complete && im.naturalWidth) im.classList.add("ld"); else im.addEventListener("load", function(){ im.classList.add("ld"); }, {once:true}); im.addEventListener("error", function(){ im.classList.add("ld"); }, {once:true}); });
  setTimeout(function(){ lazies.forEach(function(im){ im.classList.add("ld"); }); }, 4000);
  if(reveals.length){
    if(reduce || !("IntersectionObserver" in window)){ reveals.forEach(function(el){ el.classList.add("in"); }); }
    else{
      var io = new IntersectionObserver(function(es){
        es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add("in"); io.unobserve(en.target); } });
      }, {threshold:.1, rootMargin:"0px 0px -6% 0px"});
      reveals.forEach(function(el){ io.observe(el); });
      setTimeout(function(){ reveals.forEach(function(el){ el.classList.add("in"); }); }, 4000); // sécurité : jamais de contenu invisible
    }
  }

  /* ---------- TOAST ---------- */
  var toast = $("#toast"), tT;
  function say(msg){ if(!toast) return; toast.textContent = msg; toast.classList.add("show"); clearTimeout(tT); tT = setTimeout(function(){ toast.classList.remove("show"); }, 2600); }

  /* ---------- PANIER SHOPIFY (AJAX) ---------- */
  function money(n){ return n.toLocaleString("fr-FR",{minimumFractionDigits:2,maximumFractionDigits:2}).replace(/ /g," ") + " €"; }
  var cartTotal = CFG.cartTotal, cartCount = CFG.cartCount;
  function renderCount(){ $$(".cart-count").forEach(function(el){ el.textContent = cartCount; el.setAttribute("data-n", cartCount); }); }
  renderCount();
  function refreshCart(cb){
    fetch("/cart.js", {headers:{"Accept":"application/json"}}).then(function(r){ return r.json(); }).then(function(c){
      cartTotal = c.total_price/100; cartCount = c.item_count; renderCount(); renderTiers(); renderDrawer(c); if(cb) cb(c);
    }).catch(function(){});
  }

  /* ---------- TIROIR PANIER : s'ouvre à l'ajout, sans quitter la page ---------- */
  var drawer = $("#drawer"), drawerBg = $(".drawer-bg"), drawerFrom = null;
  function mk(tag, cls, txt){ var e = document.createElement(tag); if(cls) e.className = cls; if(txt != null) e.textContent = txt; return e; }
  function renderDrawer(c){
    if(!drawer || !c) return;
    majPlus(c);
    var lines = $("[data-drawer-lines]", drawer), tot = $("[data-drawer-total]", drawer), n = $("[data-drawer-count]", drawer);
    if(tot) tot.textContent = money(c.total_price/100);
    if(n) n.textContent = c.item_count ? "· " + c.item_count : "";
    if(!lines) return;
    lines.innerHTML = "";
    if(!c.items.length){ lines.appendChild(mk("li", "empty", "Ton panier est vide.")); return; }
    c.items.forEach(function(it){
      var li = mk("li"); li.setAttribute("data-key", it.key);
      var a = mk("a"); a.href = it.url;
      if(it.image){ var im = mk("img"); im.src = it.image + (it.image.indexOf("?")>-1 ? "&" : "?") + "width=168"; im.alt = ""; im.width = 84; im.height = 84; im.decoding = "async"; a.appendChild(im); }
      li.appendChild(a);
      var body = mk("div"), b = mk("b", null, it.product_title); body.appendChild(b);
      if(it.variant_title && it.variant_title !== "Default Title") body.appendChild(mk("div", "muted small", it.variant_title));
      var q = mk("div", "qty"), minus = mk("button", null, "−"), out = mk("output", null, it.quantity), plus = mk("button", null, "+");
      minus.type = plus.type = "button"; minus.setAttribute("aria-label", "Moins"); plus.setAttribute("aria-label", "Plus");
      minus.addEventListener("click", function(){ changeLine(it.key, it.quantity - 1, li); });
      plus.addEventListener("click", function(){ changeLine(it.key, it.quantity + 1, li); });
      q.appendChild(minus); q.appendChild(out); q.appendChild(plus); body.appendChild(q);
      var rm = mk("button", "rm", "Retirer"); rm.type = "button"; rm.addEventListener("click", function(){ changeLine(it.key, 0, li); }); body.appendChild(rm);
      li.appendChild(body);
      li.appendChild(mk("div", "pl-price", money(it.final_line_price/100)));
      lines.appendChild(li);
    });
  }
  function changeLine(key, qty, li){
    if(li) li.classList.add("busy");
    fetch("/cart/change.js", {method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"}, body: JSON.stringify({id: key, quantity: Math.max(0, qty)})})
      .then(function(r){ return r.json(); }).then(function(c){ cartTotal = c.total_price/100; cartCount = c.item_count; renderCount(); renderTiers(); renderDrawer(c); if(document.body.classList.contains("template-cart")) location.reload(); })
      .catch(function(){ if(li) li.classList.remove("busy"); say("Impossible de modifier pour l'instant."); });
  }
  function openDrawer(from){
    if(!drawer) return;
    drawerFrom = from || document.activeElement;
    drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); drawer.removeAttribute("inert"); if(drawerBg) drawerBg.hidden = false;
    root.classList.add("drawer-open"); document.body.style.overflow = "hidden";
    var f = drawer.querySelector("[data-drawer-close]"); if(f) setTimeout(function(){ f.focus(); }, 60);
  }
  function closeDrawer(){
    if(!drawer || !drawer.classList.contains("open")) return;
    drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); drawer.setAttribute("inert", ""); if(drawerBg) drawerBg.hidden = true;
    root.classList.remove("drawer-open"); document.body.style.overflow = "";
    if(drawerFrom && drawerFrom.focus) drawerFrom.focus();
  }
  $$("[data-drawer-close]").forEach(function(b){ b.addEventListener("click", closeDrawer); });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeDrawer(); });
  // Le bouton panier de la barre ouvre le tiroir partout, sauf sur la page panier
  var cartLink = $(".nav a[href$='/cart']");
  if(cartLink && drawer && !document.body.classList.contains("template-cart")) cartLink.addEventListener("click", function(e){ e.preventDefault(); openDrawer(cartLink); refreshCart(); });

  function addToCart(id, qty, title, btn){
    var label = btn ? btn.innerHTML : null;
    if(btn){ btn.disabled = true; btn.classList.add("busy"); }
    return fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"}, body: JSON.stringify({items:[{id: parseInt(id,10), quantity: qty}]})})
      .then(function(r){ if(!r.ok) throw new Error("add"); return r.json(); })
      .then(function(){
        /* Sur une fiche produit le tiroir ne s'ouvre pas : il casse la lecture
           et ramène l'expérience à un tunnel classique (brief du 12 sept.).
           Une confirmation en place suffit, le compteur de palier fait le reste. */
        var surFiche = document.body.classList.contains("template-product");
        refreshCart(function(){
          if(drawer && !surFiche) openDrawer(btn); else say("Ajouté : " + title);
        });
        $$(".cart-count").forEach(function(el){ el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); });
        if(btn){ btn.innerHTML = "Ajouté ✓"; setTimeout(function(){ btn.innerHTML = label; btn.disabled = false; btn.classList.remove("busy"); }, 1600); }
      })
      .catch(function(){ say("Impossible d'ajouter pour l'instant."); if(btn){ btn.innerHTML = label; btn.disabled = false; btn.classList.remove("busy"); } });
  }


  /* Changer l'image principale = changer src ET srcset. Depuis que l'image
     LCP porte un srcset (PageSpeed du 13 sept. : 435 Ko d'images
     surdimensionnées sur mobile), poser seulement src ne suffit plus : le
     navigateur continue de choisir dans le srcset. Les URL Shopify portent
     la largeur en paramètre, on la fait varier. */
  function poserImage(img, url){
    if(!img || !url) return;
    if(/[?&]width=\d+/.test(url)){
      var w = [480, 768, 1024, 1400];
      img.srcset = w.map(function(x){ return url.replace(/([?&]width=)\d+/, "$1" + x) + " " + x + "w"; }).join(", ");
    } else {
      img.removeAttribute("srcset");
    }
    img.src = url;
  }
  /* ---------- VIDÉOS (29 sept.) : bulles sous les vignettes, boîte de lecture ---------- */
  $$("[data-video-first]").forEach(function(b){ b.addEventListener("click", function(){ var first = $("[data-video]"); if(first) first.click(); }); });
  $$("[data-video]").forEach(function(b){
    b.addEventListener("click", function(){
      var d = document.getElementById(b.getAttribute("data-video")); if(!d || !d.showModal) return;
      var sl = $("[data-slides]"); if(sl && sl._stop) sl._stop();
      d.showModal();
      var v = $("video", d); if(v){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }
    });
  });
  $$(".vmodal").forEach(function(d){
    function fermer(){ var v = $("video", d); if(v) v.pause(); if(d.open) d.close(); }
    $$("[data-vm-close]", d).forEach(function(x){ x.addEventListener("click", fermer); });
    d.addEventListener("click", function(e){ if(e.target === d) fermer(); });
    d.addEventListener("close", function(){ var v = $("video", d); if(v) v.pause(); });
  });

  /* ---------- COMPLÉMENTS DU PANIER (19 oct., proposition 4) ----------
     Un produit déjà dans le panier n'est plus proposé ; la boîte disparaît
     quand il ne reste rien. Sur la page panier, l'ajout recharge la page
     (totaux rendus par Liquid) ; dans le tiroir, le tiroir se redessine. */
  function majPlus(c){
    var ids = ((c && c.items) || []).map(function(it){ return String(it.product_id); });
    $$("[data-pp-box]").forEach(function(box){
      var n = 0;
      $$("[data-pp]", box).forEach(function(li){ var dedans = ids.indexOf(li.getAttribute("data-pid")) > -1; li.hidden = dedans; if(!dedans) n++; });
      box.hidden = n === 0;
    });
  }
  $$("[data-pp-v]").forEach(function(sel){ sel.addEventListener("change", function(){
    var li = sel.closest("[data-pp]"), pr = li ? $(".pp-p", li) : null, o = sel.options[sel.selectedIndex];
    if(pr && o && o.getAttribute("data-p")) pr.textContent = o.getAttribute("data-p");
  }); });
  $$("[data-pp-add]").forEach(function(btn){ btn.addEventListener("click", function(){
    var li = btn.closest("[data-pp]"), sel = li ? $("[data-pp-v]", li) : null, id = sel ? sel.value : btn.getAttribute("data-pp-add");
    btn.disabled = true;
    fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"}, body: JSON.stringify({items:[{id: parseInt(id,10), quantity: 1}]})})
      .then(function(r){ if(!r.ok) throw new Error("add");
        if(document.body.classList.contains("template-cart")){ location.reload(); return; }
        refreshCart(); say("Ajouté : " + (btn.getAttribute("data-title") || "")); btn.disabled = false; })
      .catch(function(){ btn.disabled = false; say("Impossible d'ajouter pour l'instant."); });
  }); });

  /* ---------- BARRES FIXES SUR TÉLÉPHONE (19 oct., propositions 1 et 17) ----------
     Fiche : prix et « Ajouter » en bas de l'écran tant que le vrai bouton n'est
     pas visible. Panier : total et « Passer au paiement », même règle. Moins de
     861 px seulement. Le bouton de la barre passe par le vrai formulaire. */
  (function(){
    var mq = window.matchMedia("(max-width:860px)");
    function suivre(bar, cible, cls){
      if(!bar || !cible || !("IntersectionObserver" in window)) return;
      /* Rattachée au body : un parent transformé (animation .rv) casse position:fixed. */
      if(bar.parentNode !== document.body) document.body.appendChild(bar);
      var vu = true;
      function maj(){ var on = mq.matches && !vu; bar.hidden = !on; root.classList.toggle(cls, on); }
      new IntersectionObserver(function(en){ vu = en[0].isIntersecting; maj(); }, {threshold: 0}).observe(cible);
      if(mq.addEventListener) mq.addEventListener("change", maj);
    }
    var bb = $("[data-buybar]"), form = $("[data-buy]");
    if(bb && form){
      suivre(bb, $(".buy-acts", form) || form, "buybar-on");
      var go = $("[data-bb-go]", bb), pr = $("[data-bb-price]", bb), src = $("[data-price]", form);
      if(src && pr && "MutationObserver" in window) new MutationObserver(function(){ pr.textContent = src.textContent; }).observe(src, {childList: true, characterData: true, subtree: true});
      if(go) go.addEventListener("click", function(){
        var age = $("[data-age]", form);
        if(age && !age.checked){ form.scrollIntoView({behavior: reduce ? "auto" : "smooth", block: "center"}); age.focus(); return; }
        var sub = $("button[type=submit]", form); if(sub) sub.click();
      });
    }
    var cb = $("[data-cart-bar]"), cbtn = $("#checkoutBtn");
    if(cb && cbtn){ suivre(cb, cbtn, "cartbar-on"); var g = $("[data-cart-bar-go]", cb); if(g) g.addEventListener("click", function(){ cbtn.click(); }); }
  })();

  // Fiche : le formulaire produit (variantes natives)
  $$("[data-buy]").forEach(function(form){
    var variants = []; try{ variants = JSON.parse(form.getAttribute("data-variants")||"[]"); }catch(e){}
    var priceEl = $("[data-price]", form), img = $("[data-main-img]"), idInput = $("input[name=id]", form), stockEl = $("[data-stock]", form);
    /* La ligne « En stock » suit la déclinaison ; le chiffre n'apparaît que bas (≤ 5) et suivi par Shopify. */
    function stock(v){ if(!stockEl) return; if(v.avail === false){ stockEl.textContent = "Déclinaison épuisée"; stockEl.className = "stock out"; } else if(v.managed && v.qty > 0 && v.qty <= 5){ stockEl.textContent = "En stock · plus que " + v.qty; stockEl.className = "stock low"; } else { stockEl.textContent = "En stock"; stockEl.className = "stock"; } }
    /* 8 oct. : une fiche à deux options (taille × couleur) a un groupe de boutons par option ;
       la déclinaison est celle qui porte toutes les valeurs cochées. Si la paire n'existe pas,
       la première option cochée l'emporte et l'autre se recale. */
    var groupes = $$("[data-opt]", form);
    function cochees(){ return groupes.map(function(g){ var r = $$("input[type=radio]", g).filter(function(i){ return i.checked; })[0]; return r ? r.value : null; }); }
    function parOptions(vals){ return variants.filter(function(v){ return v.opts && v.opts.every(function(x, k){ return x === vals[k]; }); })[0]; }
    function current(){
      if(groupes.length){
        var vals = cochees(), hit = parOptions(vals);
        if(hit) return hit;
        return variants.filter(function(v){ return v.opts && v.opts[0] === vals[0]; })[0] || variants[0];
      }
      var checked = $$("input[name=variant]", form).filter(function(i){ return i.checked; })[0];
      var id = checked ? checked.value : (idInput ? idInput.value : form.getAttribute("data-variant"));
      return variants.filter(function(v){ return String(v.id)===String(id); })[0] || variants[0];
    }
    function recaler(){
      /* recale les boutons sur la déclinaison retenue, puis barre les paires absentes ou épuisées */
      if(!groupes.length) return;
      var v = current(); if(!v || !v.opts) return;
      groupes.forEach(function(g, k){
        $$("label", g).forEach(function(l){
          var r = $("input[type=radio]", l); if(!r) return;
          if(r.value === v.opts[k]) r.checked = true;
          var essai = v.opts.slice(); essai[k] = r.value;
          var w = parOptions(essai);
          l.classList.toggle("out", !w || w.avail === false);
        });
      });
    }
    var epuise = !$("button[type=submit]", form); /* épuisé : pas de bouton, le prix reste « Épuisé » */
    function sync(user){ var v = current(); if(!v) return; if(priceEl && !epuise) priceEl.textContent = money(v.price); if(img && v.image){ poserImage(img, v.image); var sl = img.closest("[data-slides]"); if(sl && sl._go && user) sl._go(0, true); } if(idInput) idInput.value = v.id; stock(v); }
    $$("input[name=variant]", form).forEach(function(i){ i.addEventListener("change", function(){ sync(true); }); });
    groupes.forEach(function(g){ $$("input[type=radio]", g).forEach(function(i){ i.addEventListener("change", function(){ recaler(); sync(true); }); }); });
    recaler(); sync();
    /* Vente interdite aux mineurs (KNF) : la case est obligatoire, sur le
       formulaire comme sur la barre qui suit. Le bouton express n'est pas
       rendu sur ces fiches, et les cartes renvoient vers la fiche. */
    function majeurOk(){
      var age = $("[data-age]", form); if(!age || age.checked) return true;
      say("Coche la case : ce matériel est réservé aux personnes majeures."); age.focus(); return false;
    }
    form.addEventListener("submit", function(e){
      e.preventDefault();
      if(!majeurOk()) return;
      var v = current(); if(!v) return;
      var qty = parseInt(($("input[name=quantity]", form)||{}).value||"1",10)||1;
      addToCart(v.id, qty, form.getAttribute("data-title") + (v.title && v.title!=="Default Title" ? " · " + v.title : ""), $("button[type=submit]", form));
    });
    /* « Passer commande » (22 sept.) : ajoute la déclinaison choisie puis va au
       paiement. Même garde-fou mineurs que le bouton d'ajout. La barre qui
       suivait le défilement est retirée : le bouton ne bouge plus. */
    var goBuy = $("[data-checkout]", form);
    if(goBuy) goBuy.addEventListener("click", function(){
      if(!majeurOk()) return;
      var v = current(); if(!v) return;
      var qty = parseInt(($("input[name=quantity]", form)||{}).value||"1",10)||1;
      goBuy.disabled = true; goBuy.classList.add("busy");
      fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"}, body: JSON.stringify({items:[{id: parseInt(v.id,10), quantity: qty}]})})
        .then(function(r){ if(!r.ok) throw new Error("add"); return fetch("/cart.js"); })
        .then(function(r){ return r.json(); })
        .then(function(c){ cartTotal = c.total_price / 100; cartCount = c.item_count; goCheckout(""); })
        .catch(function(){ say("Impossible d'ajouter pour l'instant."); goBuy.disabled = false; goBuy.classList.remove("busy"); });
    });
  });
  $$("[data-add]").forEach(function(btn){ btn.addEventListener("click", function(){
    var gate = btn.getAttribute("data-age-gate");
    if(gate){ location.href = gate; return; }
    addToCart(btn.getAttribute("data-add"), 1, btn.getAttribute("data-title"), btn); }); });

  /* ---------- ÉPUISÉ : « préviens-moi » (22 sept.) ----------
     Le relais reçoit {type:"alerte", email, handle, produit, consent} et
     écrit un métaobjet alerte_stock. Sans relais configuré, on le dit. */
  $$("[data-alerte-form]").forEach(function(f){
    var msg = $(".alerte-msg", f), email = $("input[type=email]", f), consent = $("input[name=consent]", f), btn = $("button[type=submit]", f);
    function dire(t, ko){ if(!msg) return; msg.textContent = t; msg.hidden = false; msg.classList.toggle("ko", !!ko); }
    f.addEventListener("submit", function(e){
      e.preventDefault();
      var url = f.getAttribute("data-relais");
      if(!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim())){ dire("Une adresse e-mail, et c'est parti.", true); if(email) email.focus(); return; }
      if(!consent || !consent.checked){ dire("Coche la case : c'est ce qui nous autorise à t'écrire.", true); if(consent) consent.focus(); return; }
      if(!url){ dire("Le relais n'est pas configuré. Écris-nous : contact@v8-equipment.com", true); return; }
      if(btn) btn.disabled = true;
      var piege = $("input[name='Site web']", f);
      fetch(url, { method:"POST", headers:{ "Content-Type":"application/json" }, body: JSON.stringify({
        type:"alerte", email: email.value.trim(), handle: f.getAttribute("data-handle"), produit: f.getAttribute("data-produit"),
        consent:"oui", "Site web": piege ? piege.value : "" }) })
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(){ dire("C'est noté. On t'écrit le jour où il revient."); if(email) email.value = ""; if(consent) consent.checked = false; })
      .catch(function(){ dire("Ça n'est pas passé. Réessaie, ou écris-nous : contact@v8-equipment.com", true); })
      .then(function(){ if(btn) btn.disabled = false; });
    });
  });
  // Carte : la déclinaison choisie change l'image, le prix et le bouton
  function applyPick(sel){
    var card = sel.closest(".plaque, [data-reb-carte]"); if(!card) return;
    var opt = sel.options[sel.selectedIndex], btn = $("[data-add], [data-reb-add]", card), price = $("[data-plaque-price]", card), img = $("[data-card-img]", card), alt = $(".pl-img img.alt", card), idIn = $("[data-pick-id]", card);
    if(btn){
      if(btn.hasAttribute("data-add")) btn.setAttribute("data-add", opt.value);
      if(btn.hasAttribute("data-reb-add")) btn.setAttribute("data-reb-add", opt.value);
      if(!btn._html) btn._html = btn.innerHTML;
      btn.disabled = opt.getAttribute("data-avail") !== "true";
      if(btn.disabled) btn.textContent = "Épuisé"; else btn.innerHTML = btn._html;
    }
    if(idIn) idIn.value = opt.value;
    if(price && opt.getAttribute("data-price")) price.textContent = money(parseInt(opt.getAttribute("data-price"),10)/100);
    var src = opt.getAttribute("data-img");
    /* 23 sept. (Gaëtan) : la pastille ne changeait pas la photo. L'image de carte porte un srcset,
       et poser src seul ne suffit pas : le navigateur continue de choisir dans le srcset. */
    if(img && src && img.getAttribute("src") !== src){ img.classList.remove("ld"); poserImage(img, src); img.addEventListener("load", function(){ img.classList.add("ld"); }, {once:true}); if(alt) alt.hidden = true; }
    var link = $("[data-card-link]", card); if(link){ link.href = link.href.split("?")[0] + "?variant=" + opt.value; }
  }
  /* ---------- DÉCLINAISONS : pastilles de couleur, tags de taille ----------
     Le <select> reste la source de vérité (caché) : tout le reste du site
     continue de le lire. Les pastilles le pilotent. */
  var TEINTE = {noir:"#111",bleu:"#2f5f9e",kaki:"#6b6b3a",vert:"#3e6b3a",bordeaux:"#6e1f2e",
    jaune:"#e5c534",teal:"#2a8a8a",gris:"#8a8a8a",beige:"#d6c7a6",marron:"#5b3a22",rose:"#e08aa6",
    sable:"#cbb894",rouge:"#b82a2a",orange:"#ff8c40",
    camo:"linear-gradient(135deg,#4c5a3a 25%,#8a7c52 25% 50%,#2e3a26 50% 75%,#6b6b3a 75%)",
    "a-tacs":"linear-gradient(135deg,#5b5f52 25%,#8b8f7c 25% 50%,#3f4238 50% 75%,#a9aa93 75%)",
    multicam:"linear-gradient(135deg,#6b5a3a 25%,#9c8a5a 25% 50%,#4a5a3a 50% 75%,#c2b28a 75%)"};
  var NOM_TAILLE = {xs:"XS",s:"S",m:"M",l:"L",xl:"XL",xxl:"XXL",xxxl:"XXXL","60l":"60 L","85l":"85 L",
    "120cm":"120","140cm":"140","160cm":"160","200cm":"200","30.1":"30.1","40.1":"40.1","50.1":"50.1"};

  function court(t){
    /* « XL / Noir/Kaki » ou « 3 places 160cm (169€) » : on garde l'essentiel */
    return t.replace(/\s*\([^)]*\)\s*/g, " ").replace(/\s*·\s*épuisé$/i, "").replace(/\s+/g, " ").trim();
  }

  function teinte(str){
    /* « noir|kaki| » → une pastille ; bicolore → une moitié chacune. Un camouflage (déjà un dégradé) reste seul. */
    var cs = (str||"").split("|").filter(Boolean);
    if(!cs.length) return "var(--card-3)";
    var a = TEINTE[cs[0]] || "var(--card-3)";
    if(cs.length < 2) return a;
    var b = TEINTE[cs[1]] || "var(--card-3)";
    if(a.indexOf("gradient") > -1 || b.indexOf("gradient") > -1) return a;
    return "linear-gradient(135deg," + a + " 50%," + b + " 50%)";
  }
  function nomCouleur(str){
    return (str||"").split("|").filter(Boolean).map(function(c){ return c.charAt(0).toUpperCase() + c.slice(1); }).join("/");
  }
  function bulles(sel){
    var hote = sel.parentNode.querySelector("[data-bulles]"); if(!hote) return;
    hote.innerHTML = "";
    var opts = Array.prototype.slice.call(sel.options), cKeys = [], sKeys = [];
    var info = opts.map(function(o){
      var c = o.getAttribute("data-colors")||"", s = (o.getAttribute("data-sizes")||"").split("|").filter(Boolean)[0]||"";
      if(c && cKeys.indexOf(c) < 0) cKeys.push(c);
      if(s && sKeys.indexOf(s) < 0) sKeys.push(s);
      return {o:o, c:c, s:s, ok:o.getAttribute("data-avail") === "true", lib:court(o.textContent)};
    });
    var tousC = info.every(function(i){ return i.c; }), tousS = info.every(function(i){ return i.s; });
    /* 8 oct. (Gaëtan) : une déclinaison par taille ET par couleur (PAC 18.1 : 4 tailles × 3 couleurs)
       sortait douze pastilles de trois couleurs, la taille invisible. Deux axes → deux rangées :
       les couleurs, puis les tailles ; la paire choisie désigne la déclinaison. */
    var mode = (tousC && tousS && cKeys.length > 1 && sKeys.length > 1) ? "duo" : (tousC ? "couleur" : (tousS ? "taille" : "texte"));
    hote.setAttribute("data-mode", mode);
    function choisir(idx){ sel.selectedIndex = idx; applyPick(sel); bulles(sel); }
    function bouton(cls){ var b = document.createElement("button"); b.type = "button"; b.className = "bulle " + cls; return b; }
    function etat(b, on, dispo, lab){ b.classList.toggle("on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); if(!dispo) b.classList.add("out"); b.setAttribute("aria-label", lab + (dispo ? "" : " — épuisé")); }

    if(mode === "duo"){
      var cur = info[sel.selectedIndex] || info[0];
      var rangC = document.createElement("div"); rangC.className = "bulles-rang"; rangC.setAttribute("role", "group"); rangC.setAttribute("aria-label", "Couleur");
      cKeys.forEach(function(ck){
        var memes = info.filter(function(i){ return i.c === ck; });
        var exact = memes.filter(function(i){ return i.s === cur.s; })[0];
        var cible = (exact && exact.ok) ? exact : (memes.filter(function(i){ return i.ok; })[0] || exact || memes[0]);
        var lab = memes[0].lib.split(" / ").filter(function(p){ return p.toLowerCase() !== (memes[0].s||"").toLowerCase(); }).join(" / ") || nomCouleur(ck);
        var b = bouton("b-couleur"); b.style.background = teinte(ck); b.title = lab;
        etat(b, ck === cur.c, memes.some(function(i){ return i.ok; }), lab);
        b.addEventListener("click", function(){ choisir(opts.indexOf(cible.o)); });
        rangC.appendChild(b);
      });
      var rangS = document.createElement("div"); rangS.className = "bulles-rang"; rangS.setAttribute("role", "group"); rangS.setAttribute("aria-label", "Taille");
      sKeys.forEach(function(sk){
        var cand = info.filter(function(i){ return i.s === sk && i.c === cur.c; })[0];
        var b = bouton("b-taille"); b.textContent = NOM_TAILLE[sk] || sk.toUpperCase();
        etat(b, sk === cur.s, !!(cand && cand.ok), b.textContent);
        if(cand) b.addEventListener("click", function(){ choisir(opts.indexOf(cand.o)); });
        else b.disabled = true;
        rangS.appendChild(b);
      });
      hote.appendChild(rangC); hote.appendChild(rangS);
      return;
    }

    for(var j=0;j<sel.options.length;j++){
      (function(o, idx){
        var b = document.createElement("button");
        b.type = "button"; b.className = "bulle b-" + mode;
        b.setAttribute("data-i", idx);
        var dispo = o.getAttribute("data-avail") === "true";
        if(!dispo) b.classList.add("out");
        var lib = court(o.textContent);
        if(mode === "couleur"){
          b.style.background = teinte(o.getAttribute("data-colors"));
          b.setAttribute("aria-label", lib + (dispo ? "" : " — épuisé"));
          b.title = lib;
        } else if(mode === "taille"){
          var t = (o.getAttribute("data-sizes")||"").split("|").filter(Boolean)[0];
          b.textContent = NOM_TAILLE[t] || (t || lib).toUpperCase();
          b.setAttribute("aria-label", lib + (dispo ? "" : " — épuisé"));
        } else {
          b.textContent = lib;
        }
        b.setAttribute("aria-pressed", idx === sel.selectedIndex ? "true" : "false");
        if(idx === sel.selectedIndex) b.classList.add("on");
        b.addEventListener("click", function(){
          sel.selectedIndex = idx; applyPick(sel);
          var tous = hote.querySelectorAll(".bulle");
          for(var k=0;k<tous.length;k++){
            var vif = k === idx;
            tous[k].classList.toggle("on", vif);
            tous[k].setAttribute("aria-pressed", vif ? "true" : "false");
          }
        });
        hote.appendChild(b);
      })(sel.options[j], j);
    }
  }

  $$("[data-pick]").forEach(function(sel){
    sel.addEventListener("change", function(){ applyPick(sel); bulles(sel); });
    bulles(sel);
  });

  // Paliers : barre + ligne dynamique
  /* Paliers : un seul cadeau, celui du palier atteint — jamais de cumul, et le
     contenu du cadeau n'est nommé nulle part. La livraison offerte est acquise
     à partir de son seuil et le reste à tous les paliers au-dessus. */
  function tierState(total){
    var t = CFG.tiers, hit = t.filter(function(x){ return total >= x; }).length;
    return {hit: hit, next: t[hit], missing: t[hit] ? t[hit] - total : 0,
            port: total >= CFG.freeShipping, avantPort: Math.max(0, CFG.freeShipping - total)};
  }
  function phraseTiers(total){
    var st = tierState(total);
    if(st.hit === 0){
      if(!st.port) return "Encore " + money(st.avantPort) + " et la livraison est offerte.";
      return "Livraison offerte. Encore " + money(st.missing) + " et tu passes le palier 1.";
    }
    if(st.next) return "Palier " + st.hit + " atteint — ton cadeau part avec la commande. Encore " + money(st.missing) + " et tu passes le palier " + (st.hit + 1) + ".";
    return "Palier " + st.hit + " atteint — ton cadeau part avec la commande.";
  }
  function renderTiers(){
    var total = cartTotal;
    $$("[data-tiers]").forEach(function(el){
      var st = tierState(total), max = CFG.tiers[CFG.tiers.length-1];
      var fill = $(".fill", el), line = $(".line", el), gifts = $(".gifts", el);
      if(fill) fill.style.width = Math.min(100, total/max*100) + "%";
      $$(".marks span", el).forEach(function(m,i){ m.classList.toggle("hit", total >= CFG.tiers[i]); });
      var fm = $("[data-free]", el); if(fm) fm.classList.toggle("hit", st.port);
      if(line) line.textContent = st.port ? "Livraison offerte." : "Livraison offerte dès " + money(CFG.freeShipping) + ".";
      if(gifts) gifts.textContent = phraseTiers(total);
    });
    $$("[data-tier-hint]").forEach(function(el){
      var price = parseFloat(el.getAttribute("data-tier-hint"));
      el.textContent = "+ ton panier passe à " + money(total + price) + ". " + phraseTiers(total + price);
    });
  }
  renderTiers();

  // Page panier (rendue par Liquid) : quantités et suppression
  $$("[data-line]").forEach(function(li){
    var line = li.getAttribute("data-line");
    function change(q){ fetch("/cart/change.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({line: line, quantity: q})}).then(function(){ location.reload(); }); }
    $$("[data-q]", li).forEach(function(b){ b.addEventListener("click", function(){ var out = $("output", li); var q = parseInt(out.textContent,10) + parseInt(b.getAttribute("data-q"),10); change(Math.max(0,q)); }); });
    var rm = $(".rm", li); if(rm) rm.addEventListener("click", function(){ change(0); });
  });

  // Vers le paiement : les attributs de commande, puis le nom signé pré-rempli si la charte est signée

  /* ---------- TRACK : à qui revient la vente ----------
     Règle posée par Gaëtan : le référencement et le direct lui reviennent,
     les réseaux sociaux et le mailing reviennent à Agathe. L'acquisition
     payante n'était pas tranchée — elle est rangée chez Gaëtan, puisque
     c'est son périmètre ; une ligne à changer si l'arbitrage bouge.

     On retient la PREMIÈRE origine, pas la dernière : le canal qui a fait
     découvrir la marque compte, pas celui du dernier clic. Mémorisée 30
     jours dans le navigateur, et jamais écrasée par une navigation interne.

     Trois attributs sortent d'ici, et ils sont séparés exprès :
       · « Attribution » = un seul mot, Gaëtan ou Agathe. C'est celui que
         Flow recopie en balise de commande, donc il doit rester propre.
       · « Canal » = un seul mot lui aussi (référencement, réseaux,
         mailing, direct, payant, site référent) : deuxième balise, c'est
         ce qui permet de voir quelle stratégie rapporte.
       · « Origine » = la trace brute (le domaine, l'utm_source). Jamais
         en balise, trop de valeurs différentes ; on la garde pour
         trancher un désaccord en regardant la donnée. */
  var TRACK = (function(){
    var CLE = "v8track", JOURS = 30;
    var MOTEURS = /google|bing|duckduckgo|ecosia|yahoo|qwant|brave|startpage|baidu|yandex/i;
    var SOCIAL  = /instagram|facebook|fb\.|tiktok|youtube|pinterest|linkedin|twitter|x\.com|snapchat|reddit|threads/i;
    var MAIL    = /mail|webmail|outlook|gmail|resend|klaviyo|brevo|sendinblue|mailchimp/i;

    function memoire(){
      try{
        var b = JSON.parse(localStorage.getItem(CLE) || "null");
        if(b && b.q && (Date.now() - b.t) < JOURS * 864e5) return b;
      }catch(e){}
      return null;
    }
    function classer(){
      var p, med = "", src = "";
      try{ p = new URLSearchParams(location.search);
           med = (p.get("utm_medium") || "").toLowerCase();
           src = (p.get("utm_source") || "").toLowerCase(); }catch(e){}
      var ref = document.referrer || "", hote = "";
      try{ hote = ref ? new URL(ref).hostname : ""; }catch(e){}
      /* une page du site qui renvoie vers une autre n'est pas une origine */
      if(hote && hote.indexOf(location.hostname) !== -1) return null;

      if(med === "email" || med === "mailing" || MAIL.test(src) || MAIL.test(hote))
        return {q:"Agathe", c:"mailing", o:src || hote || "mailing"};
      if(med === "social" || SOCIAL.test(src) || SOCIAL.test(hote))
        return {q:"Agathe", c:"réseaux", o:src || hote || "réseaux"};
      if(med === "cpc" || med === "ppc" || med === "paid" || med.indexOf("paid") === 0)
        return {q:"Gaëtan", c:"payant", o:src || hote || "payant"};
      /* 20 oct. : une pub Google sans UTM porte gclid ; un clic venu de Facebook ou
         d'Instagram porte fbclid, ou s'ouvre dans le navigateur intégré de l'appli
         (sans referrer). Avant, les deux tombaient en « direct ». Sans UTM, on ne
         sait pas si le clic Meta était payé : il reste en « réseaux », origine meta.
         Les pubs Meta doivent porter utm_medium=paid pour sortir en « payant ». */
      var fb = false, ua = navigator.userAgent || "";
      try{ if(p.get("gclid") || p.get("gbraid") || p.get("wbraid")) return {q:"Gaëtan", c:"payant", o:"google"}; fb = !!p.get("fbclid"); }catch(e){}
      if(fb || /FBAN|FBAV|FB_IAB|Instagram/i.test(ua))
        return {q:"Agathe", c:"réseaux", o:"meta" + (fb ? " · fbclid" : " · appli")};
      if(med === "organic" || MOTEURS.test(hote))
        return {q:"Gaëtan", c:"référencement", o:hote || src || "référencement"};
      if(!ref) return {q:"Gaëtan", c:"direct", o:"direct"};
      return {q:"Gaëtan", c:"site référent", o:hote};
    }
    var vu = memoire();
    if(!vu){
      var c = classer();
      if(c){ vu = {q:c.q, c:c.c, o:c.o, t:Date.now()};
             try{ localStorage.setItem(CLE, JSON.stringify(vu)); }catch(e){} }
    }
    /* les visites mémorisées avant la séparation du canal n'ont pas de « c » */
    if(vu && !vu.c) vu.c = (vu.o || "direct").split(" · ")[0];
    return vu || {q:"Gaëtan", c:"direct", o:"direct"};
  })();

  function goCheckout(signature){
    var st = tierState(cartTotal);
    var attributes = { "Palier": st.hit ? "palier-" + CFG.tiers[st.hit-1] : "aucun", "Saison": CFG.season.name,
                       "Attribution": TRACK.q, "Canal": TRACK.c, "Origine": TRACK.o };
    if(signature){ attributes["Charte signée par"] = signature; attributes["Charte signée le"] = new Date().toISOString(); }
    var url = "/checkout";
    if(signature){
      var bits = signature.split(/\s+/), first = bits.shift(), last = bits.join(" ");
      url += "?checkout[shipping_address][first_name]=" + encodeURIComponent(first) + (last ? "&checkout[shipping_address][last_name]=" + encodeURIComponent(last) : "");
    }
    fetch("/cart/update.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({attributes: attributes})})
      .then(function(){ location.href = url; }).catch(function(){ location.href = url; });
  }
  var goBtn = $("#checkoutBtn");
  if(goBtn) goBtn.addEventListener("click", function(){
    if(cartCount<1){ say("Ton panier est vide."); return; }
    goBtn.disabled = true; goBtn.classList.add("busy");
    goCheckout((($("input[name=signature]")||{}).value||"").trim());
  });
  $$("[data-drawer-checkout]").forEach(function(b){ b.addEventListener("click", function(){ if(cartCount<1){ say("Ton panier est vide."); return; } b.disabled = true; goCheckout(""); }); });

  /* ---------- GALERIE : une image fixe, les autres dessous, rotation toutes les 5 s ----------
     22 sept. (Gaëtan) : plus de changement d'image au défilement. Survol =
     pause ; clic sur une vignette ou balayage = arrêt définitif ;
     prefers-reduced-motion = pas de rotation. */
  $$("[data-slides]").forEach(function(sl){
    var fr = $$("img", sl), th = $$(".thumbs button", sl.parentNode), i = 0, timer = null, manual = false, vu = true;
    function go(n, user){
      i = (n + fr.length) % fr.length;
      fr.forEach(function(f,k){ f.classList.toggle("on", k===i); });
      th.forEach(function(b,k){ if(k===i) b.setAttribute("aria-current","true"); else b.removeAttribute("aria-current"); });
      if(user){ manual = true; stop(); }
    }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function start(){ if(reduce || manual || timer || fr.length < 2) return; timer = setInterval(function(){ if(!document.hidden && vu) go(i+1); }, 5000); }
    sl._go = go; sl._stop = stop; sl._start = start;
    th.forEach(function(b,k){ b.addEventListener("click", function(){ go(k, true); }); });
    if(fr.length > 1){
      if(fine){ sl.addEventListener("pointerenter", stop); sl.addEventListener("pointerleave", start); }
      var x0 = null;
      sl.addEventListener("pointerdown", function(e){ x0 = e.clientX; }, {passive:true});
      sl.addEventListener("pointerup", function(e){ if(x0===null) return; var dx = e.clientX - x0; x0 = null; if(Math.abs(dx) > 40) go(dx < 0 ? i+1 : i-1, true); });
      if("IntersectionObserver" in window){ new IntersectionObserver(function(en){ vu = en[0].isIntersecting; }, {threshold:.2}).observe(sl); }
      start();
    }
  });

  /* ---------- LAMPE TORCHE : un seul endroit du site ---------- */
  var torch = $(".torch");
  if(torch && !reduce){
    var lit = false, exit = function(){ if(!lit){ lit = true; torch.classList.add("lit"); } };
    if(fine){
      torch.addEventListener("mousemove", function(e){
        var r = torch.getBoundingClientRect();
        torch.style.setProperty("--tx", ((e.clientX-r.left)/r.width*100)+"%");
        torch.style.setProperty("--ty", ((e.clientY-r.top)/r.height*100)+"%");
      });
    }
    setTimeout(exit, 9000);                       // une sortie : au bout de quelques secondes…
    window.addEventListener("scroll", function(){ var r = torch.getBoundingClientRect(); if(r.top < 0) exit(); }, {passive:true}); // …ou au premier défilement passé
    torch.addEventListener("click", exit);
  }

  /* ---------- WHATSAPP : message pré-rempli avec le trigramme ---------- */
  $$("[data-wa]").forEach(function(a){
    var tri = a.getAttribute("data-wa") || "";
    if(CFG.whatsapp){ a.href = "https://wa.me/" + CFG.whatsapp + "?text=" + encodeURIComponent("Salut, j'ai une question sur le " + tri + " : "); }
    else { a.setAttribute("aria-disabled","true"); a.addEventListener("click", function(e){ e.preventDefault(); say("Le numéro WhatsApp arrive avant le 23 septembre."); }); }
  });

  /* ---------- FILTRES (boutique) : catégorie, taille, couleur, à gauche ---------- */
  var shop = $("#shopFilters");
  if(shop){
    var cards = $$(".plaque[data-cat]");
    var LABELS = {colors:{noir:"Noir",bleu:"Bleu",kaki:"Kaki",vert:"Vert",bordeaux:"Bordeaux",jaune:"Jaune",teal:"Teal",gris:"Gris",beige:"Beige",marron:"Marron",rose:"Rose",sable:"Sable",rouge:"Rouge",orange:"Orange",camo:"Camo",["a-tacs"]:"A-TACS",multicam:"Multicam"},
                  sizes:{xs:"XS",s:"S",m:"M",l:"L",xl:"XL",xxl:"XXL",xxxl:"XXXL","60l":"60 L","85l":"85 L","30.1":"30.1","40.1":"40.1","50.1":"50.1","120cm":"120 cm","140cm":"140 cm","160cm":"160 cm","200cm":"200 cm"}};
    /* Les 16 catégories sont illisibles à plat : on les range sous les quatre
       univers de l'ancien site (bivouac, sacs, VTT, vêtements). Chaque univers
       se replie, et sa case coche ou décoche toutes ses catégories d'un coup. */
    var UNIVERS = [
      ["Bivouac",   ["Tentes de Toit","Tentes pour Motos","Accessoires de Camping","Divers"]],
      ["Sacs",      ["Sacs Urbains","Sacs de Voyage","Sacs d'Hydratation","Sacs Tactiques / Militaires"]],
      ["VTT",       ["Hydratation","Dorsales VTT","Gants VTT","Bagagerie","VTT"]],
      ["V\u00eatements", ["Vestes coupe vent","V\u00eatements","Casquettes et bonnets"]]
    ];
    var SIZE_ORDER = ["xs","s","m","l","xl","xxl","xxxl","30.1","40.1","50.1","60l","85l","120cm","140cm","160cm","200cm"];
    var SWATCH = {noir:"#111",bleu:"#2f5f9e",kaki:"#6b6b3a",vert:"#3e6b3a",bordeaux:"#6e1f2e",jaune:"#e5c534",teal:"#2a8a8a",gris:"#8a8a8a",beige:"#d6c7a6",marron:"#5b3a22",rose:"#e08aa6",sable:"#cbb894",rouge:"#b82a2a",orange:"#ff8c40",camo:"linear-gradient(135deg,#4c5a3a 25%,#8a7c52 25% 50%,#2e3a26 50% 75%,#6b6b3a 75%)",["a-tacs"]:"linear-gradient(135deg,#5b5f52 25%,#8b8f7c 25% 50%,#3f4238 50% 75%,#a9aa93 75%)",multicam:"linear-gradient(135deg,#6b5a3a 25%,#9c8a5a 25% 50%,#4a5a3a 50% 75%,#c2b28a 75%)"};
    function vals(el, k){ return (el.getAttribute("data-" + k)||"").split("|").filter(Boolean); }
    var facets = {cat:{}, sizes:{}, colors:{}};
    cards.forEach(function(c){
      var t = c.getAttribute("data-cat"); if(t) facets.cat[t] = (facets.cat[t]||0) + 1;
      var seenS = {}, seenC = {};
      vals(c,"sizes").forEach(function(v){ if(!seenS[v]){ seenS[v] = 1; facets.sizes[v] = (facets.sizes[v]||0) + 1; } });
      vals(c,"colors").forEach(function(v){ if(!seenC[v]){ seenC[v] = 1; facets.colors[v] = (facets.colors[v]||0) + 1; } });
    });
    var state = {cat:[], sizes:[], colors:[]};

    function caseFacette(k, v, box){
      var lab = document.createElement("label"); lab.className = "fopt";
      var inp = document.createElement("input"); inp.type = "checkbox"; inp.value = v; inp.setAttribute("data-facet-key", k);
      var txt = document.createElement("span"); txt.textContent = (LABELS[k] && LABELS[k][v]) || v;
      var n = document.createElement("small"); n.textContent = facets[k][v];
      lab.appendChild(inp);
      if(k === "colors" && SWATCH[v]){ var sw = document.createElement("i"); sw.className = "sw"; sw.style.background = SWATCH[v]; lab.appendChild(sw); }
      lab.appendChild(txt); lab.appendChild(n); box.appendChild(lab);
      inp.addEventListener("change", function(){
        state[k] = $$("input[data-facet-key=" + k + "]:checked", shop).map(function(i){ return i.value; });
        if(k === "cat") majUnivers();
        apply();
      });
      return inp;
    }

    /* --- catégorie : deux niveaux --- */
    var boxCat = $("[data-facet=cat]", shop), unis = [];
    if(boxCat){
      var restants = Object.keys(facets.cat);
      UNIVERS.forEach(function(u){
        var dedans = u[1].filter(function(t){ return facets.cat[t]; });
        if(!dedans.length) return;
        dedans.forEach(function(t){ restants.splice(restants.indexOf(t), 1); });
        var total = dedans.reduce(function(a,t){ return a + facets.cat[t]; }, 0);
        var det = document.createElement("details"); det.className = "funi";
        var sum = document.createElement("summary");
        var chk = document.createElement("input"); chk.type = "checkbox"; chk.className = "funi-all";
        chk.setAttribute("aria-label", "Tout " + u[0]);
        var nom = document.createElement("span"); nom.textContent = u[0];
        var nb  = document.createElement("small"); nb.textContent = total;
        sum.appendChild(chk); sum.appendChild(nom); sum.appendChild(nb);
        var corps = document.createElement("div"); corps.className = "fopts funi-in";
        det.appendChild(sum); det.appendChild(corps); boxCat.appendChild(det);
        var fils = dedans.map(function(t){ return caseFacette("cat", t, corps); });
        unis.push({chk: chk, fils: fils, det: det});
        chk.addEventListener("click", function(e){ e.stopPropagation(); });
        chk.addEventListener("change", function(){
          fils.forEach(function(i){ i.checked = chk.checked; });
          state.cat = $$("input[data-facet-key=cat]:checked", shop).map(function(i){ return i.value; });
          majUnivers(); apply();
        });
      });
      /* ce qui n'entre dans aucun univers reste accessible */
      if(restants.length){
        var det2 = document.createElement("details"); det2.className = "funi";
        var s2 = document.createElement("summary"); var n2 = document.createElement("span"); n2.textContent = "Autres";
        s2.appendChild(document.createElement("i")); s2.appendChild(n2);
        var c2 = document.createElement("div"); c2.className = "fopts funi-in";
        det2.appendChild(s2); det2.appendChild(c2); boxCat.appendChild(det2);
        restants.sort(function(a,b){ return a.localeCompare(b, "fr"); }).forEach(function(t){ caseFacette("cat", t, c2); });
      }
    }

    function majUnivers(){
      unis.forEach(function(u){
        var n = u.fils.filter(function(i){ return i.checked; }).length;
        u.chk.checked = n === u.fils.length && n > 0;
        u.chk.indeterminate = n > 0 && n < u.fils.length;
        if(n) u.det.open = true;
      });
    }

    /* --- taille et couleur : à plat --- */
    ["sizes","colors"].forEach(function(k){
      var box = $("[data-facet=" + k + "]", shop); if(!box) return;
      var keys = Object.keys(facets[k]);
      if(k === "sizes") keys.sort(function(a,b){ return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); }); else keys.sort(function(a,b){ return a.localeCompare(b, "fr"); });
      if(!keys.length){ var g = box.closest(".fgroup"); if(g) g.hidden = true; return; }
      keys.forEach(function(v){ caseFacette(k, v, box); });
    });
    function pickColor(card){
      var sel = $("[data-pick]", card); if(!sel || !state.colors.length) return;
      for(var i=0;i<sel.options.length;i++){
        var oc = (sel.options[i].getAttribute("data-colors")||"").split("|");
        if(state.colors.some(function(c){ return oc.indexOf(c) > -1; })){ if(sel.selectedIndex !== i){ sel.selectedIndex = i; applyPick(sel); bulles(sel); } return; }
      }
    }
    /* Pour chaque option, le nombre de fiches qu'elle laisserait compte tenu
       des DEUX autres facettes. À zéro, la puce disparaît, la catégorie
       s'estompe : on ne propose jamais un clic qui mène à une page vide. */
    function compte(){
      ["cat","sizes","colors"].forEach(function(k){
        $$("input[data-facet-key=" + k + "]", shop).forEach(function(inp){
          var v = inp.value, n = 0;
          cards.forEach(function(c){
            var okCat = k === "cat" ? c.getAttribute("data-cat") === v : (!state.cat.length || state.cat.indexOf(c.getAttribute("data-cat")) > -1);
            var okS = k === "sizes" ? vals(c,"sizes").indexOf(v) > -1 : (!state.sizes.length || vals(c,"sizes").some(function(x){ return state.sizes.indexOf(x) > -1; }));
            var okC = k === "colors" ? vals(c,"colors").indexOf(v) > -1 : (!state.colors.length || vals(c,"colors").some(function(x){ return state.colors.indexOf(x) > -1; }));
            if(okCat && okS && okC) n++;
          });
          var lab = inp.closest(".fopt"), small = lab && lab.querySelector("small");
          if(small) small.textContent = n;
          if(lab) lab.classList.toggle("vide", n === 0 && !inp.checked);
        });
      });
    }
    function apply(){
      var active = state.cat.length || state.sizes.length || state.colors.length, shown = 0;
      cards.forEach(function(c){
        var ok = (!state.cat.length || state.cat.indexOf(c.getAttribute("data-cat")) > -1)
              && (!state.sizes.length || vals(c,"sizes").some(function(v){ return state.sizes.indexOf(v) > -1; }))
              && (!state.colors.length || vals(c,"colors").some(function(v){ return state.colors.indexOf(v) > -1; }));
        c.hidden = !ok; if(ok){ shown++; pickColor(c); }
      });
      root.classList.toggle("filtering", !!active);
      $$("[data-shop-section]").forEach(function(sec){
        var any = $$(".plaque[data-cat]", sec).some(function(c){ return !c.hidden; });
        /* la section qui porte le message « rien ne correspond » reste
           visible quand il n'y a plus rien, sinon le message ne s'affiche jamais */
        var porteVide = !!$("[data-shop-empty]", sec);
        sec.hidden = active && (sec.hasAttribute("data-hide-when-filtering") || (!any && !(porteVide && shown === 0)));
      });
      compte();
      var empty = $("[data-shop-empty]"); if(empty) empty.hidden = !(active && shown === 0);
      var cnt = $("[data-result-count]", shop); if(cnt) cnt.textContent = active ? shown + (shown > 1 ? " pièces" : " pièce") : cards.length + " pièces";
      var n = $("[data-filter-count]", shop), total = state.cat.length + state.sizes.length + state.colors.length; if(n) n.textContent = total ? "· " + total : "";
      $$("[data-filter-reset]").forEach(function(b){ if(b.closest("#shopFilters")) b.hidden = !active; });
    }
    $$("[data-filter-reset]").forEach(function(b){ b.addEventListener("click", function(){ $$("input[type=checkbox]", shop).forEach(function(i){ i.checked = false; i.indeterminate = false; }); state = {cat:[], sizes:[], colors:[]}; apply(); }); });
    var tog = $(".shop-toggle", shop);
    if(tog) tog.addEventListener("click", function(){ var o = shop.classList.toggle("open"); tog.setAttribute("aria-expanded", o); });
    // Les univers : un clic coche la catégorie
    $$("[data-uni]").forEach(function(a){ a.addEventListener("click", function(){
      var cible = a.getAttribute("data-uni"), voulu = null;
      for(var i=0;i<UNIVERS.length;i++){ if(UNIVERS[i][0] === cible) voulu = UNIVERS[i][1]; }
      if(!voulu) voulu = [cible];
      $$("input[data-facet-key=cat]", shop).forEach(function(i){ i.checked = voulu.indexOf(i.value) > -1; });
      state.cat = $$("input[data-facet-key=cat]:checked", shop).map(function(i){ return i.value; });
      majUnivers(); apply();
    }); });
    apply();
  }

  /* ---------- SAISON FERMÉE : le bouton change, la fiche reste ---------- */
  if(phase==="closed"){
    var band = document.createElement("div"); band.className = "closed-band";
    band.textContent = "La saison d'automne est fermée. L'" + CFG.season.next.replace(/^l'/,"") + " ouvre le 23 décembre.";
    document.body.insertBefore(band, document.body.firstChild);
    $$("[data-buy] .cta").forEach(function(b){
      b.textContent = "Préviens-moi à l'ouverture de " + CFG.season.next;
      b.type = "button"; b.addEventListener("click", function(e){ e.preventDefault(); location.href = "/aide.html#alerte"; });
    });
  }

  /* ---------- HISTOIRE EN FRISE (page la-marque, 22 sept.) ----------
     La hauteur de la section = largeur de la frise moins l'écran, plus un
     écran : un pixel vertical vaut un pixel horizontal. Recalculé au
     redimensionnement et quand les images arrivent. */
  $$("[data-histoire]").forEach(function(sec){
    if(root.classList.contains("reduce")) return;
    var track = $("[data-htrack]", sec), prog = $("[data-hprog]", sec); if(!track) return;
    var max = 0, top = 0, H = 0;
    function mesure(){
      var w = track.scrollWidth, vw = window.innerWidth;
      max = Math.max(0, w - vw + 2 * Math.min(60, vw * 0.06));
      H = max + window.innerHeight; sec.style.height = H + "px";
      top = sec.getBoundingClientRect().top + window.scrollY; place();
    }
    function place(){
      var y = window.scrollY - top, d = Math.max(1, H - window.innerHeight);
      var p = Math.min(1, Math.max(0, y / d));
      var pad = Math.min(60, window.innerWidth * 0.06);
      track.style.transform = "translate3d(" + (pad - p * max) + "px,0,0)";
      if(prog) prog.style.width = (p * 100) + "%";
    }
    window.addEventListener("scroll", place, {passive:true});
    window.addEventListener("resize", mesure);
    $$("img", track).forEach(function(im){ if(!im.complete) im.addEventListener("load", mesure, {once:true}); });
    mesure(); setTimeout(mesure, 800);
  });

  /* ---------- TABLEAU DE LIÈGE : au clic, l'entrée se dépunaise et s'ouvre en grand ---------- */
  var papers = $$(".cork .paper");
  if(papers.length){
    var lb = document.createElement("div"); lb.className = "lightbox"; lb.setAttribute("role","dialog"); lb.setAttribute("aria-modal","true"); lb.setAttribute("aria-label","Entrée du journal");
    document.body.appendChild(lb);
    var closeLb = function(){ lb.classList.remove("open"); lb.innerHTML = ""; };
    papers.forEach(function(pp){
      pp.setAttribute("tabindex","0"); pp.setAttribute("role","button");
      var open = function(){ var c = pp.cloneNode(true); c.removeAttribute("style"); c.removeAttribute("tabindex"); var pin = c.querySelector(".pin"); if(pin) pin.remove(); lb.innerHTML = ""; lb.appendChild(c); lb.classList.add("open"); };
      pp.addEventListener("click", open);
      pp.addEventListener("keydown", function(e){ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); open(); } });
    });
    lb.addEventListener("click", function(e){ if(e.target===lb) closeLb(); });
    document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeLb(); });
  }


  /* ---------- VITRINE : la progression du défilement pilote trois variables ---------- */
  var shows = $$("[data-show]");
  if(shows.length){
    if(reduce){
      shows.forEach(function(s){ s.classList.add("on-uni"); });
    } else {
      var showTick = function(){
        shows.forEach(function(s){
          var r = s.getBoundingClientRect(), vh = window.innerHeight || 1;
          var span = Math.max(1, r.height - vh);
          var p = Math.min(1, Math.max(0, -r.top / span));
          // trois temps : le produit arrive, l'univers apparaît, les étiquettes se posent
          var seg = function(a,b){ return Math.min(1, Math.max(0, (p - a) / (b - a))); };
          var st = s.style;
          st.setProperty("--p1", seg(0.02, 0.24).toFixed(3));
          st.setProperty("--p2", seg(0.30, 0.56).toFixed(3));
          st.setProperty("--p3", seg(0.62, 0.86).toFixed(3));
          s.classList.toggle("on-uni", p > 0.42);
        });
      };
      var showQueued = false;
      var onShowScroll = function(){
        if(showQueued) return; showQueued = true;
        requestAnimationFrame(function(){ showQueued = false; showTick(); });
      };
      window.addEventListener("scroll", onShowScroll, {passive:true});
      window.addEventListener("resize", onShowScroll, {passive:true});
      showTick();
      // Le décor de l'univers n'est chargé qu'à l'approche de la section
      if("IntersectionObserver" in window){
        var bgio = new IntersectionObserver(function(es){
          es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add("armed"); bgio.unobserve(en.target); } });
        }, {rootMargin:"200% 0px"});
        shows.forEach(function(s){ bgio.observe(s); });
      }
    }
  }

  /* ---------- FORMULAIRES SANS BACK-END : repli e-mail ---------- */
  $$("form[data-mailto]").forEach(function(f){
    f.addEventListener("submit", function(e){
      e.preventDefault();
      var to = f.getAttribute("data-mailto"), subject = f.getAttribute("data-subject")||"Message depuis v8-equipment.com";
      var body = $$("input,textarea,select", f).filter(function(i){ return i.name && i.type!=="file"; }).map(function(i){ return i.name + " : " + i.value; }).join("\n");
      location.href = "mailto:" + to + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body + "\n\n(Photos : réponds à cet e-mail avec 1 à 3 photos en pièce jointe.)");
      var ok = $("[data-sent]", f.parentElement); if(ok){ ok.hidden = false; }
    });
  });
})();
